import { getBestPriceForDateRangeAction } from "../../../../Actions/LogicActions/Search/GetBestPriceForDateRangeAction";
import { outboundInboundDateAction } from "../../../../Actions/UIActions/Search/OutboundInboundDateAction";
import { ExecutionStatus } from "../../../../core/enum/ExecutionStatus";
import { _eventBus } from "../../../../core/events/EventBus";
import { StepDefinition } from "../../../../core/flows/StepDefinition";
import { StepFlow } from "../../../../core/flows/StepFlow";
import { evtTree } from "../../../../Orchestrator/ConstantTree";
import { SearchStateTypeWithDates } from "../../../../Orchestrator/Types/Index";
import { IGetRangeBestPriceActionParams } from "../../../../Orchestrator/Types/Interface/ActionParams/CalendarBestPrice";
import { SearchContext } from "../Context/SearchContext";

class SelectDateStep extends StepFlow {
    get stepName() { return "SelectSearchDate_Step"; }

    async onEventSetup(): Promise<void> {
        this.registerEventSubscription(
            _eventBus.on<SearchStateTypeWithDates, void>({
                eventName: evtTree.SearchBar.SelectDate.Select,
                handler: async (payload) => {
                    let context = this.getCtx<SearchContext>("searchContext")!
                    context.searchStateTypeWithDates = payload.data!
                    await outboundInboundDateAction.setParams({ ...context.searchStateTypeWithDates })
                    await outboundInboundDateAction.execute()
                    if (outboundInboundDateAction.status.executionStatus === ExecutionStatus.SUCCESS) {
                        context.searchStateAtom = outboundInboundDateAction.result!
                    }
                }
            })
        )
        
        this.registerEventSubscription(
            _eventBus.on<IGetRangeBestPriceActionParams, void>({
                eventName: evtTree.SearchBar.SelectDate.BestPrice,
                handler: async (payload) => {
                    getBestPriceForDateRangeAction.setParams(payload.data!)
                    await getBestPriceForDateRangeAction.execute()
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<void, void>({
                eventName: evtTree.SearchBar.SelectOrigin.Blur,
                handler: () => {
                    let context = this.getCtx<SearchContext>("searchContext")!
                    context.stepRoute = "SearchStartupInit_Step"
                    this.next()
                }
            })
        )
    }

    async onExecute(): Promise<void> {
    }
}

export const SelectSearchDateStepDeclaration = new StepDefinition({
    stepName: "SelectSearchDate_Step",
    stepClass: SelectDateStep
});